export function getMimetype(signature, type) {
  switch (signature) {
    case "0000":  
      return type == "application/msword";
    case "25504446":
      return type == "application/pdf";
      case "5B6F626A":
        return (type == "application/pdf" ||  "text/csv");
    case "496E6475":
      return type == "text/csv";
      case "EFBBBF22":
        return type == "text/csv";
    case "69642C74":
      return type == "text/csv";
      case "5B6F626A":
        return type == "text/csv";
    case "D0CF11E0":
      return (type == "application/vnd.ms-excel" ||  "application/vnd.ms-powerpoint");

    case "DA3C21":
      return type == "application/vnd.ms-excel";
    case "47554944":
      return type == "text/plain";
      case "46697265":
        return type == "text/plain";
      case "2D2D2046":
        return type == "text/plain";
      case "0000":
        return type == "text/plain";
    case "DADA":
      return type == "text/plain";

    case "74657374":
      return type == "text/plain";

    case "FFFE610":
      return type == "text/plain";
      case "307C5450":
        return type == "text/plain";
        case "4D696372":
          return type == "text/plain";
          case "53454C45":
            return type == "text/plain";
    case "EFBFBD50":
      return type == "image/png";
      case "89504E47":
        return type == "image/png";
        case "75EFBFBD":
          return type == "image/png";
    case "FFD8FFE0":
      return type == "image/jpeg";

    case "FFD8FFE0":
      return type == "image/jpg";

      

      case "D0CF11E0":  
    return type === "application/msword";  

      case "504B34":  
    return (  
      type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||   
      type === "application/vnd.openxmlformats-officedocument.presentationml.presentation" ||   
      type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"  
    );  

      
    
    default:
      return false;
  }
}
